export default "__VITE_ASSET__BBZw8AlI__"